export default "__VITE_ASSET__DRz94Vfh__"